import React from "react";
// Components
import { Icon } from "@evidenceb/athena-common/design-system/Icon";
// SCSS
import "./Error.scss";
// Interfaces
interface ErrorProps {
    error: string;
}
const Error = ({ error }: ErrorProps) => {
    return (
        <div className="auth-error" aria-live="assertive">
            <Icon path="warning_outline" style={{ marginInlineEnd: 8 }} />{" "}
            <span>{error}</span>
        </div>
    );
};

export default Error;
